import { Entity } from '../../../../base/Entity'

export type PersistedTypePrimaryKeyType = number
export const persistedTypePrimaryKeyAttributeName: 'id' = 'id'
export interface PersistedTypeAttributesType {
  id: number
  type_declaration: any
  type_symbol: string
  full_domain_name?: string
}

export class PersistedType<
  AttributesType extends PersistedTypeAttributesType = PersistedTypeAttributesType
> extends Entity<PersistedTypePrimaryKeyType, AttributesType> {
  static readonly modelName: string = 'PersistedType'
  static readonly entityName: string = 'PersistedType'
  static readonly primaryKeyAttributeName: 'id' = 'id'

  get id (): PersistedTypePrimaryKeyType {
    return this.primaryKey
  }

  get associationPropertyPaths (): string[][] { return [] }
  readonly hasAssociations: false = false

  get type_declaration (): AttributesType['type_declaration'] {
    return this.readAttribute('type_declaration')
  }

  get type_symbol (): AttributesType['type_symbol'] {
    return this.readAttribute('type_symbol')
  }

  get full_domain_name (): AttributesType['full_domain_name'] {
    return this.readAttribute('full_domain_name')
  }
}
